import {useDashboard} from '../../../hooks/kpi/useDashboard'
import {formatMonetaryToBr} from '../../../utils/formatMonetaryToBr'

import {BottonTopProducts} from './componente/BottonTopProducts.'
import {useState} from 'react'

interface TopProductsProps {
  className: string
}

export function TopProducts({className}: TopProductsProps) {
  const {query} = useDashboard()
  const topProducts = query.data?.topProducts.itens ?? []
  const totalSaleItems = query.data?.topProducts.total ?? 0
  const isLoading = query.isLoading

  const hasData = !isLoading && topProducts && topProducts?.length > 0
  const hasNotData = !isLoading && topProducts && topProducts?.length == 0

  const [selectedTab, setSelectedTab] = useState(1)

  const handleTabClick = (id: number) => {
    setSelectedTab(id)
  }

  const filteredProducts = topProducts?.filter((product) => product.category_id === selectedTab)

  return (
    <div className={`card ${className}`}>
      <div className='card-header border-0 pt-5'>
        <h3 className='card-title align-items-start flex-column'>
          <span className='card-label fw-bold fs-3 mb-1'>Produtos mais vendidos</span>
          <span className='text-muted mt-1 fw-semibold fs-7'>
            Total vendido: {totalSaleItems} itens
          </span>
        </h3>
      </div>

      <div className='d-flex flex-wrap flex-stack'>
        <div className='d-flex flex-column flex-grow-1 pe-8'>
          <div className='d-flex align-items-center py-3 px-4 me-6 mb-1'>
            <BottonTopProducts
              name='Depilação'
              id={1}
              icon='ki-outline ki-design-2 fs-1'
              isActive={selectedTab === 1}
              onClick={handleTabClick}
            />

            <BottonTopProducts
              name='Estética'
              id={2}
              icon='ki-outline ki-abstract-12 fs-1'
              isActive={selectedTab === 2}
              onClick={handleTabClick}
            />
            <BottonTopProducts
              name='Produto'
              id={3}
              icon='ki-outline ki-speaker fs-1'
              isActive={selectedTab === 3}
              onClick={handleTabClick}
            />
          </div>
        </div>
      </div>

      <div className='card-body py-3 overflow-hidden'>
        {isLoading && (
          <div
            className='text-center flex flex-center'
            style={{overflowY: 'auto', height: 200, display: `flex`}}
          >
            <span style={{alignSelf: `center`}}>Carregando...</span>
          </div>
        )}

        {!isLoading && filteredProducts?.length === 0 && (
          <div className='text-center d-flex flex-center' style={{height: 200}}>
            <span>Nenhum dado disponível</span>
          </div>
        )}
        {filteredProducts && filteredProducts.length > 0 && (
          <div className='table-responsive' style={{height: 400, overflowY: 'auto'}}>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <tbody>
                {filteredProducts.map((product, index) => (
                  <tr key={`product-${index}`}>
                    <td>
                      <div className='d-flex align-items-center'>
                        <div className='symbol symbol-40px me-4'>
                          <span className='symbol-label' style={{backgroundColor: 'transparent'}}>
                            <i
                              className={`fa-solid fa-${index == 0 ? 'trophy' : index + 1} ${
                                index == 0 ? 'fa-flip' : ''
                              } fs-4`}
                              style={{
                                animationIterationCount: index === 0 ? '2' : '0',
                                animationTimingFunction: 'cubic-bezier(1, 1.6, 2, 1)',
                                color: index === 0 ? 'rgb(255,255,25)' : '#cdcdde',
                              }}
                            ></i>
                            <span className='fw-bold fs-2 p-1 h-45px text-gray-500'>
                              {index !== 0 && 'º'}
                            </span>
                          </span>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span
                        className='text-dark fw-bold text-hover-danger d-block fs-7'
                        data-bs-toggle='tooltip'
                        data-bs-placement='top'
                        data-bs-delay='{"show": 100, "hide": 100}'
                        title={product.product_name.toUpperCase()}
                      >
                        {product.product_name.length > 8
                          ? `${product.product_name.substring(0, 7).toUpperCase()}...`
                          : product.product_name.toUpperCase()}
                      </span>
                      <span className='text-muted fw-semibold d-block fs-7'>
                        {product.category_name}
                      </span>
                    </td>
                    <td>
                      <span className='text-dark text-center fw-bold d-block fs-6'>
                        {product.total_sold}
                      </span>
                      <span className='text-muted fw-semibold d-block fs-7 text-center'>
                        Volume
                      </span>
                      <span className='text-dark fw-bold d-block fs-7 text-center'>
                        {formatMonetaryToBr(product.total_price) ?? '---'}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  )
}
